import type { IPatient } from '../../common/interfaces/patient';
import type { IEmployment } from '../components/interfaces/employment';
import type { IServiceGetOne } from '../components/interfaces/serviceGetOne';
import { checkServiceAndEmploymentUsesZorgmail } from '../../common/checkServiceAndEmploymentUsesZorgmail';
import { ServiceType } from '../../common/enums/serviceType';
import { getJson } from '../store/fetch';

export async function checkUsesZorgmail(serviceId: string, patient: IPatient, employmentId: string) {
    const serviceResult = await getJson('/api/services/' + serviceId);
    const service: IServiceGetOne = serviceResult.json;

    if (service.serviceType !== ServiceType.examination && service.serviceType !== ServiceType.consultation) {
        return false;
    }

    const employmentResult = await getJson('/api/employments/' + employmentId);
    const employment: IEmployment = employmentResult.json;

    if (
        patient.careProviderPractitionerId !== employment.practitionerId ||
        patient.careProviderOrganizationId !== employment.organizationId
    ) {
        return false;
    }

    return checkServiceAndEmploymentUsesZorgmail(service, employment);
}
